<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  ><!-- Icon from Remix Icon by Remix Design - https://github.com/Remix-Design/RemixIcon/blob/master/License -->
    <path
      fill="currentColor"
      d="m12 18.26l-7.053 3.948l1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34l8.027.952l-5.934 5.488l1.575 7.928z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#999'
    },
    stroke: {
      type: String,
      default: ''
    },
    strokeWidth: {
      type: Number,
      default: 40
    },
  }
}
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
}
</style>